import React, { Fragment, useState } from "react";
import "../Reporting.css";
import ReportingModals from "../../../../shared/Modals/ReportingModals";
import arrowImg from "../../../../assets/purple.svg";

const TotalSales = (props) => {
  const [lgShow, setLgShow] = useState(false);

  return (
    <Fragment>
      <div
        onClick={(e) => {
          props?.check ? setLgShow(true) : e.preventDefault();
        }}
        className=""
      >
        <span className="patient_style">
          Total Sales
          <img src={arrowImg} alt="" className="arrow-img ml-2" />
        </span>
      </div>
      <div
        onClick={(e) => {
          props?.check ? setLgShow(true) : e.preventDefault();
        }}
        id={props?.divId}
      ></div>
      {setLgShow ? (
        <ReportingModals
          setLgShow={setLgShow}
          lgShow={lgShow}
          show={5}
          title={"Total Sales"}
        />
      ) : (
        ""
      )}
    </Fragment>
  );
};
export default TotalSales;